import React, { Fragment } from 'react';

import useGroupSelectType from './UseGroupSelectType';

import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import RadioButtonList from '@usas/ui-web/components/radiobuttonlists/RadiobuttonList';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css'

const GroupSelectType = () => {
  const {
    isLoading,
    state,
    formState,
    errorState,
    onSelectedGroupTypeChange,
    onContinueClicked,
    onBackClicked
  } = useGroupSelectType();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12 col-sm-6">
          {state.orgGroupTypes.length === 0
            ? <p>Loading...</p>
            : <RadioButtonList
              label={"Select Group Type"}
              name={"selectedGroupType"}
              items={state.orgGroupTypes}
              error={errorState.selectedGroupType}
              message={errorState.selectedGroupType}
              value={formState.selectedGroupType}
              isVertical={true}
              onChange={(value) => { onSelectedGroupTypeChange(value) }} />
          }
        </div>
        <div className="col-xs-12 col-sm-6">
          <div>
            <p><b>Group Type Description:</b></p>
            <p>{formState.selectedGroupTypeDescription}</p>
          </div>
        </div>
      </div>
      {state.continueErrorMessage &&
        <div className="row">
          <div className="col-xs-12">
            <p className={global.ErrorMessage}>{state.continueErrorMessage}</p>
          </div>
        </div>}
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12 usas-extra-top-margin">
          <PrimaryButton type="button" onClick={onContinueClicked}>Continue</PrimaryButton>&nbsp;
          <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default GroupSelectType;